var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXIconLogo = function SvgXIconLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x-icon-logo_svg__a)",
    d: "M20.536 31.936a.532.532 0 0 1 0 1.064H3.665a3.65 3.65 0 0 1-2.59-1.078A3.66 3.66 0 0 1 0 29.334V3.668c0-1.01.413-1.927 1.076-2.59l.031-.029A3.66 3.66 0 0 1 3.667.001h1.496a.532.532 0 0 1 0 1.065H3.666a2.61 2.61 0 0 0-2.602 2.602v25.666c0 .716.293 1.368.766 1.84.47.469 1.121.761 1.836.761h16.872zm-3.6-18.625 6.73-8.184a.53.53 0 0 1 .438-.23h2.998c.12.003.238.042.337.124a.53.53 0 0 1 .072.747l-8.556 10.404 7.83 11.091a.531.531 0 0 1-.434.837l-4.075.002a.53.53 0 0 1-.453-.253l-5.76-8.16-6.729 8.183a.53.53 0 0 1-.438.23H5.898a.54.54 0 0 1-.337-.123.53.53 0 0 1-.072-.747l8.556-10.403-7.83-11.093A.531.531 0 0 1 6.65 4.9h4.075c.191 0 .36.101.454.252l5.76 8.162zM12.462 1.065a.532.532 0 0 1 0-1.065h16.87c1.01 0 1.927.413 2.591 1.076l.03.031A3.66 3.66 0 0 1 33 3.667v25.665a3.66 3.66 0 0 1-1.078 2.591A3.66 3.66 0 0 1 29.332 33h-1.495a.532.532 0 0 1 0-1.064h1.495c.717 0 1.369-.293 1.838-.763a2.6 2.6 0 0 0 .765-1.84V3.669a2.61 2.61 0 0 0-2.602-2.602h-16.87z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "x-icon-logo_svg__a",
    x1: -2.475,
    x2: 35.475,
    y1: 16.5,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3932D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0140FF"
  })))));
};
export default SvgXIconLogo;